import { StyleSheet } from 'react-native';
import { MediaQueryStyleSheet } from "react-native-responsive";

export default MediaQueryStyleSheet.create({
  root: {
    flexDirection: 'column',
    paddingVertical: 6,
  },
});
